// src/contexts/AdminAlertContext.js
import { createContext, useState, useEffect, useContext } from 'react';
import { buildWsUrl } from '../utils/websocket';

const AdminAlertContext = createContext();

export const AdminAlertProvider = ({ children }) => {
    const [hasPendingCoupon, setHasPendingCoupon] = useState(false);

    useEffect(() => {
        const ws = new WebSocket(buildWsUrl('/ws/admin/items/'));
        ws.onopen = () => console.log('✅ WebSocket connected: admin/items');
        ws.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                if (data.type === 'item.action_request') {
                    console.log('🔔 새 승인 요청 도착!');
                    setHasPendingCoupon(true);
                }
            } catch (err) {
                console.error('WebSocket Error:', err);
            }
        };
        ws.onclose = () => console.warn('❌ WebSocket closed');
        return () => ws.close();
    }, []);

    const clearPending = () => setHasPendingCoupon(false);

    return (
        <AdminAlertContext.Provider value={{ hasPendingCoupon, clearPending }}>
            {children}
        </AdminAlertContext.Provider>
    );
};

export const useAdminAlert = () => useContext(AdminAlertContext);
